function e(){if("undefined"==typeof document)return{};return document.cookie.split(";").reduce(((e,t)=>{const[n,r]=t.trim().split("=");return e[n]=r,e}),{})}export{e as getCookiesAsObject};
//# sourceMappingURL=get-cookies.js.map
